import React, { useState } from "react";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./Contact_Form.css";
import Success_Modal from "../../Common_Components/common_modal/success_modal/Success_Modal";
import PhoneInput from "react-phone-input-2";

const Contact_Form = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [phone, setPhone] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Your API / form submission logic here
    setShowSuccessModal(true);
  };

  return (
    <section className="Contact_Form">
      <Container>
        <CommonHeading title="Send us a Message" />

        {/* FORM */}
        <div className="form_div">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control placeholder="Your full name" required />
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Email Address *</Form.Label>
                  <Form.Control placeholder="Your@email.com" required />
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group className="form_group">
                  <Form.Label>
                    Phone Number <span>*</span>
                  </Form.Label>

                  <PhoneInput
                    country={"in"}
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    placeholder="Enter your phone number"
                    inputClass="phone_input"
                    containerClass="phone_input_container"
                    buttonClass="phone_country_btn"
                    required
                  />

                  {/* <Form.Control
                      type="tel"
                      maxLength={10}
                      placeholder="Enter your phone number"
                    /> */}
                </Form.Group>
              </Col>

              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Subject *</Form.Label>
                  <Form.Control placeholder="Query subject" />
                </Form.Group>
              </Col>

              <Col md={12} className="mb-3">
                <Form.Group>
                  <Form.Label>Message *</Form.Label>
                  <textarea
                    placeholder="Please describe your query..."
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <button className="submit_btn" type="submit">
              Submit
            </button>
          </Form>
        </div>
      </Container>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
      />
    </section>
  );
};

export default Contact_Form;
